import { action } from "easy-peasy";
import { IProjectDetails } from "../interface/projectDetails";
import { ListSectionProps } from "../../types/sectionTypes";

export const projectDetails: IProjectDetails = {
  projectDetails: {
    sections: [],
    elements: [],
    references: [],
    mapElements: [],
    spools: [],
  },

  setProjectDetails: action((state, payload) => {
    state.projectDetails = payload;
  }),

  resetProjectDetails: action((state) => {
    state.projectDetails = {
      sections: [],
      elements: [],
      references: [],
      mapElements: [],
      spools: [],
    };
  }),

  addSection: action((state, payload) => {
    const newSections = [...state.projectDetails.sections, payload];
    state.projectDetails.sections = newSections;
  }),

  removeSection: action((state, payload) => {
    const newSections = state.projectDetails.sections.filter(
      (_section) => _section.sectionID !== payload
    );
    state.projectDetails.sections = newSections;
  }),

  updateSection: action((state, payload: Partial<ListSectionProps>) => {
    const sections = [...state.projectDetails.sections];
    const editedSection = sections.find(
      (_sections) => _sections.sectionID === payload.sectionID
    );
    if (editedSection) {
      Object.entries(payload).forEach(([key, value]) => {
        if (value && key !== "sectionID") {
          editedSection[key] = value;
        }
      });
    }
    state.projectDetails.sections = sections;
  }),

  updateRevision: action((state, payload) => {
    const sections = [...state.projectDetails.sections];
    let index = sections.findIndex(
      (_sections) => _sections.sectionID === payload.sectionID
    );

    if (index !== -1) {
      sections[index].file = payload.file;
      sections[index].fileToken = payload.fileToken;
      sections[index].fileName = payload.fileName;
      sections[index].revision = payload.revision;
    }
    state.projectDetails.sections = sections;
  }),

  addElement: action((state, payload) => {
    const elements = [...state.projectDetails.elements, payload];
    state.projectDetails.elements = elements;
  }),

  updateElement: action((state, payload) => {
    const elements = [...state.projectDetails.elements];
    let index = elements.findIndex((_element) => _element.id === payload.id);
    if (index !== -1) {
      elements[index] = { ...elements[index], ...payload };
    }
    state.projectDetails.elements = elements;
  }),

  removeElement: action((state, payload) => {
    const elements = state.projectDetails.elements.filter(
      (item) => item.id !== payload
    );
    state.projectDetails.elements = elements;
  }),

  addReference: action((state, payload) => {
    const newReferences = [...state.projectDetails.references, payload];
    state.projectDetails.references = newReferences;
  }),

  updateReference: action((state, payload) => {
    const references = [...state.projectDetails.references];
    let index = references.findIndex(
      (_reference) => _reference.id === payload.id
    );
    if (index !== -1) {
      references[index] = { ...references[index], ...payload };
    }
    state.projectDetails.references = references;
  }),

  removeReference: action((state, payload) => {
    const references = state.projectDetails.references.filter(
      (item) => item.id !== payload
    );
    state.projectDetails.references = references;
  }),

  clearReferences: action((state, payload) => {
    const references = state.projectDetails.references.filter(
      (item) => item.sourceElementID !== payload
    );
    state.projectDetails.references = references;
  }),

  addMapElements: action((state, payload) => {
    const newAdditional = [...state.projectDetails.mapElements, payload];
    state.projectDetails.mapElements = newAdditional;
  }),

  updateMapElements: action((state, payload) => {
    const additional = [...state.projectDetails.mapElements];
    let index = additional.findIndex(
      (_additional) => _additional.id === payload.id
    );
    if (index !== -1) {
      additional[index] = { ...additional[index], ...payload };
    }
    state.projectDetails.mapElements = additional;
  }),

  removeMapElements: action((state, payload) => {
    const additional = state.projectDetails.mapElements.filter(
      (item) => item.id !== payload
    );
    state.projectDetails.mapElements = additional;
  }),

  addSpool: action((state, payload) => {
    const spools = [...state.projectDetails.spools, payload];
    state.projectDetails.spools = spools;
  }),

  updateSpool: action((state, payload) => {
    const spools = [...state.projectDetails.spools];
    let index = spools.findIndex(
      (_spool) => _spool.spoolID === payload.spoolID
    );
    if (index !== -1) {
      const instaceIndex = spools[index].instances.findIndex(
        (_instance) => _instance.instanceID === payload.instanceID
      );
      if (instaceIndex !== -1) {
        spools[index].instances[instaceIndex] = {
          ...spools[index].instances[instaceIndex],
          ...payload.instance,
        };
      }
    }
    state.projectDetails.spools = spools;
  }),

  updateDetailsSpool: action((state, payload) => {
    const spools = [...state.projectDetails.spools];
    let index = spools.findIndex(
      (_spool) => _spool.spoolID === payload.spoolID
    );
    if (index !== -1) {
      spools[index] = { ...spools[index], ...payload.spool };
    }
    state.projectDetails.spools = spools;
  }),
  removeSpool: action((state, payload) => {
    const spools = state.projectDetails.spools.filter(
      (item) => item.spoolID !== payload
    );
    state.projectDetails.spools = spools;
    const elements = [...state.projectDetails.elements];
    elements.forEach((element) => {
      if (element.spoolID === payload) {
        element.spoolID = "";
      }
    });
    state.projectDetails.elements = elements;
  }),

  removeSpoolInstance: action((state, payload) => {
    const newSpool = [...state.projectDetails.spools];

    const spools = newSpool.find((item) => item.spoolID === payload.spoolID);
    if (spools) {
      spools.instances = spools.instances.filter(
        (instance) => instance.instanceID !== payload.instanceID
      );
    }
    state.projectDetails.spools = newSpool;
  }),

  addSpoolInstance: action((state, payload) => {
    const spools = [...state.projectDetails.spools];
    let index = spools.findIndex(
      (_spool) => _spool.spoolID === payload.spoolID
    );
    if (index !== -1) {
      spools[index].instances = [...spools[index].instances, payload.instance];
    }
    state.projectDetails.spools = spools;
  }),
};
